module.exports = __webpack_public_path__ + "static/media/early-warning-signs@3x.b72e874c.png";